// extracted by mini-css-extract-plugin
export default {"strate":"strate___Hjnsc","strate--no-padding":"strate--no-padding___uSKrG","strate__skip-link":"strate__skip-link___Fl5Bc"};